module.exports = __webpack_public_path__ + "static/media/Cycler_Poster.91d22e8e.svg";